import { localStorageSync } from 'ngrx-store-localstorage'
import { ActionReducer } from '@ngrx/store'
import { isPublicIframePath } from '../shared/utils/iframe'

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: [
      'auth',
      'configurationOptions',
      'oidc',
      ...(!isPublicIframePath() ? ['persistent-tags'] : []),
      'persistent-user-role',
      'answers'
    ],

    rehydrate: true,
    storageKeySerializer: (key) => 'delcom_' + key
  })(reducer)
}
